import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

const Testing = () => {
    return (
        <div className="teboil-testing">
            <FullWrapper>
                <div className="teboil-testingWrapper">
                    <div className="teboil-testingTitle">Тестирование</div>
                    <div className="teboil-seoList">
                        Финальный шаг&nbsp;&mdash; проверка работы сценариев интернет-магазина.
                        Протестировали поведение в&nbsp;условиях высокой нагрузки, проверили
                        пользовательские сценарии взаимодействия с&nbsp;момента регистрации
                        до&nbsp;этапа получения статусов по&nbsp;оплаченным заказам. Проверили
                        рекомендации SEO-специалистов.
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Testing;
